import { useEffect } from 'react';
import { useOrganization, useOrganizationList } from '@clerk/clerk-react';

/**
 * If the user has at least one Clerk Organization membership but no active org,
 * activate the first one. Without this, admins who just signed in would see
 * the outreacher 403 screen because their JWT wouldn't carry the `o` claim
 * the backend's `isAdminPayload` check depends on.
 */
export function useAutoActivateOrg(): void {
  const { organization, isLoaded: orgLoaded } = useOrganization();
  const { userMemberships, isLoaded: listLoaded, setActive } = useOrganizationList({
    userMemberships: { infinite: false },
  });

  useEffect(() => {
    if (!orgLoaded || !listLoaded) return;
    if (organization) return;
    if (!setActive) return;
    const first = userMemberships?.data?.[0]?.organization;
    if (first) {
      void setActive({ organization: first.id });
    }
  }, [orgLoaded, listLoaded, organization, userMemberships, setActive]);
}
